<template>
    <Card>
        <m-query ref="searchForm" @onSubmit="beforeSubmit" :formData="formData" :loading="loading"></m-query>
        <Tabs :value="billTab" @on-click="tabClick" :animated="false">
            <TabPane :label="$t('deliveryNoticeConfirm.t9')" name="detailed">
                <Button type="primary" class="each-btn" @click="beforeConfirmDetailed" key="confirmDetailed"
                        :disabled="detailedSelection.length == 0" :loading="loading" size="small">
                    {{$t('deliveryNoticeConfirm.t35')}}
                </Button>
                <Button :loading="loading" type="primary" class="each-btn" @click="exportOutDetailed" style="margin-left:10px;"
                :disabled="detailedData.length == 0 || !formData.items[0].value" size="small">
                {{$t('deliveryNoticeConfirm.t36')}}
                </Button>
                <set-table style="margin-left:10px;" :columns="detailedCols" buttonSize="small" columnsKey="detail" @setTableUpdate="setTableUpdate"></set-table>

                <Table class="detailedTable" style="margin-top:10px;" :columns="detailedCols" :data="detailedData" :loading="loading"
                       border ref="detailedTable"
                        needScrollBar
                        needSticky
                       thDrag
                       columnDrag
                       :height="500"
                       stripe highlight-row disabled-hover size="small"
                       @on-selection-change="handleDetailedSelectionChange"></Table>
                <div style="margin-top:10px;text-align:right;position:relative;z-index:99;">
                    <Page :total="total1" :pageSize="pageSize1" show-elevator  show-total size="small" transfer show-sizer @on-change="onPageChange1" :page-size-opts="pageSizeArray" @on-page-size-change="onPageSizeChange1" placement="top" />
                </div>
            </TabPane>
            <TabPane :label="$t('deliveryNoticeConfirm.t34')" name="summary">
                <Button @click="confirmSummary" key="confirmSummary" type="primary" class="each-btn"
                        :disabled="summarySelection.length == 0" :loading="loading" size="small">
                    {{$t('deliveryNoticeConfirm.t35')}}
                </Button>
                <Button :loading="loading" @click="exportOutSummary" type="primary" :disabled="summaryData.length == 0 || !formData.items[0].value" style="margin-left:10px;"
                size="small">{{$t('deliveryNoticeConfirm.t36')}}
                </Button>
                <set-table style="margin-left:10px;" :columns="summaryCols" buttonSize="small" columnsKey="summary" @setTableUpdate="setSummaryTableUpdate"></set-table>

                <Table class="summaryTable" style="margin-top:10px;" :columns="summaryCols" :data="summaryData" :loading="loading"
                       border ref="summaryTable"
                        needScrollBar
                        needSticky
                       thDrag
                       columnDrag
                       :height="500"
                       stripe highlight-row disabled-hover size="small"
                       @on-selection-change="handleSummarySelectionChange"></Table>
                <div style="margin-top:10px;text-align:right;position:relative;z-index:99;">
                    <Page :total="total2" :pageSize="pageSize2" show-elevator  show-total size="small" transfer show-sizer @on-change="onPageChange2" :page-size-opts="pageSizeArray"  @on-page-size-change="onPageSizeChange2" placement="top" />
                </div>
            </TabPane>
        </Tabs>
    </Card>
</template>
<script>
import mQuery from '@/components/awesome/page/query';
import axios from 'axios';
import scrollBar from '@/utils/table-scroll-bar.js';
import sticky from '@/utils/sticky.js';

export default {
    name: 'deliveryNoticeConfirm',
    mixins: [scrollBar, sticky],
    data () {
        return {
            parent: 'detailedTable', // 用于固定表头sticky
            tableRefName: 'detailedTable', // 用于虚拟滚动条scrollBar
          formData: {
                row: 3,
                items: [
                    {
                        value: '',
                        field: 'orgCode',
                        disabled: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('deliveryNoticeConfirm.t38')
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('deliveryNoticeConfirm.t1')
                    },
                    {
                        value: '',
                        field: 'sourceTypeCode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change() {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('deliveryNoticeConfirm.t2')
                    },
                    {
                        value: '',
                        field: 'needByDateStart',
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        type: 'datePicker',
                        title: this.$t('deliveryNoticeConfirm.t3'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'needByDateEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'releasedDateStart',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        type: 'datePicker',
                        title: this.$t('deliveryNoticeConfirm.t4'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'releasedDateEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2
                        },
                        style: 'width:100%',
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'wipentityNamesStart',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('deliveryNoticeConfirm.t5'),
                        isDouble: true
                    },
                    {
                        value: '',
                        field: 'wipentityNamesEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        hide: true
                    },
                    {
                        value: '',
                        field: 'itemCodeStart',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('deliveryNoticeConfirm.t7')
                    },
                    {
                        value: '',
                        title: this.$t('deliveryNoticeConfirm.t8'),
                        field: 'itemCodeEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        value: '',
                        field: 'scheduledStartDateStart',
                        validators: {
                        },
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        style: 'width:100%',
                        options: {
                            type: 'datetime',
                            format: 'yyyy-MM-dd HH:mm:ss'
                        },
                        type: 'datePicker',
                        title: this.$t('deliveryNoticeConfirm.t6'),
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'scheduledStartDateEnd',
                        validators: {
                        },
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2
                        },
                        style: 'width:100%',
                        options: {
                            type: 'datetime',
                            format: 'yyyy-MM-dd HH:mm:ss',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        change: (obj, val) => {
                            if (val) {
                                if (val.split(' ')[1].indexOf('00:00:00') > -1) {
                                    obj.value = `${val.split(' ')[0]} 23:59:59`;
                                }
                            }
                        },
                        type: 'datePicker',
                        title: ''
                    },
                ],
            },
            loading: false,
            billTab: 'detailed',
            detailedData: [],
            detailedCols: [
                {
                    type: 'selection',
                    align: 'center',
                    width: 30
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t11'), // 物料编码
                    key: 'itemCode',
                    width: 140,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t12'), // 物料描述
                    key: 'itemName',
                    width: 220,
                    tooltip: true
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t13'), // 单位
                    key: 'primaryUomCode',
                    align: 'center',
                    width: 60
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t14'), // 要求数量
                    key: 'releasedQuantity',
                    width: 70,
                    align: 'right'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t16'), // 作业开始时间
                    key: 'scheduledStartDate',
                    width: 130,
                    sortable: true
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t17'), // 要求时间
                    key: 'needByDate',
                    width: 130,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t19'), // 承诺时间
                    key: 'promisedDate',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('DatePicker', {
                            props: {
                                type: 'datetime',
                                size: 'small',
                                value: params.row.promisedDate
                            },
                            style: {
                                display: 'block'
                            },
                            on: {
                                'on-change': (data) => {
                                    params.row.promisedDate = data;
                                    this.detailedData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t20'), // 买方
                    key: 'organizationName',
                    width: 60,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t21'), // 厂区
                    key: 'locationCode',
                    width: 150,
                    align: 'center',
                    tooltip: true
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t22'), // 车间
                    key: 'departmentCode',
                    width: 100,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t10'), // 子库
                    key: 'subInventory',
                    width: 70,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t15'), // 作业号
                    key: 'wipentityNames',
                    width: 120,
                    tooltip: true
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t18'), // 生产线
                    key: 'planLineDesc',
                    width: 120,
                    align: 'center',
                    tooltip: true
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t23'), // 作业状态
                    key: 'meaning',
                    width: 100,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t24'), // 通知下达时间
                    key: 'releasedDate',
                    width: 125,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t25'), // 备货方式
                    key: 'feedType',
                    width: 100,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t26'), // 通知类型
                    key: 'sourceTypeMeaning',
                    width: 100,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t27'), // 通知号
                    key: 'notifyNumber',
                    width: 120,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t28'), // 订单号
                    key: 'poNumber',
                    width: 120,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t29'), // 订单行号
                    key: 'poLineNumber',
                    width: 50,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t30'), // 项目号
                    key: 'projectNumber',
                    width: 100,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t31'), // 说明
                    key: 'comments',
                    width: 100,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t32'), // 是否同意
                    key: 'selectFlag',
                    render: (h, params) => {
                        let selectOption = [
                            h('Option', {
                                props: {
                                    value: 'Y'
                                }
                            }, this.$t('common.yes')),
                            h('Option', {
                                props: {
                                    value: 'N'
                                }
                            }, this.$t('common.no'))
                        ];
                        return h('Select', {
                            props: {
                                value: params.row.selectFlag,
                                disabled: this.disabledReject,
                                size: 'small'
                            },
                            on: {
                                'on-change': (value) => {
                                    params.row.selectFlag = value;
                                    if (value === 'Y') {
                                        params.row.promisedDate = new Date().getTime();
                                        params.row.rejectReason = '';
                                    } else {
                                        params.row.promisedDate = '';
                                    }
                                    this.detailedData[params.index] = params.row;
                                }
                            }
                        }, selectOption);
                    },
                    width: 60
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t33'), // 拒绝原因
                    key: 'rejectReason',
                    render: (h, params) => {
                        if (!this.disabledReject) {
                            return h('Input', {
                                props: {
                                    value: params.row.rejectReason,
                                    size: 'small'
                                },
                                on: {
                                    'on-blur': (event) => {
                                        params.row.rejectReason = event.target.value;
                                        this.detailedData[params.index] = params.row;
                                    }
                                }
                            });
                        }
                    },
                    width: 150
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t47'), // MCO变更标识
                    key: 'plmMcoChangeCode',
                    width: 100,
                    align: 'center',
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t48'), // MCO变更说明
                    key: 'plmMcoChangeRemark',
                    width: 100,
                    align: 'center',
                },
            ],
            tableHeight: 550,
            detailedSelection: [],
            total1: 0,
            page1: 1,
            pageSize1: 300,
            pageSizeArray: [100, 200, 300],
            summaryData: [],
            summaryCols: [
                {
                    type: 'selection',
                    align: 'center',
                    width: 60
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t1'), // 库存组织
                    key: 'organizationName',
                    minWidth: 50,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t11'), // 物料编码
                    key: 'itemCode',
                    minWidth: 140,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t12'), // 物料描述
                    key: 'itemName',
                    minWidth: 300,
                    tooltip: true
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t14'), // 要求数量
                    key: 'allReleasedQty',
                    minWidth: 80,
                    align: 'right'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t17'), // 需求时间
                    key: 'needByDate',
                    minWidth: 110,
                    align: 'center'
                },
                {
                    title: this.$t('deliveryNoticeConfirm.t32'), // 是否同意
                    key: 'selectFlag',
                    render: (h, params) => {
                        let selectOption = [
                            h('Option', {
                                props: {
                                    value: 'Y'
                                }
                            }, this.$t('common.yes')),
                            h('Option', {
                                props: {
                                    value: 'N'
                                }
                            }, this.$t('common.no'))
                        ];
                        return h('Select', {
                            props: {
                                value: params.row.selectFlag,
                                size: 'small',
                                disabled: true
                            },
                            on: {
                                'on-change': (value) => {
                                    params.row.selectFlag = value;
                                    if (value === 'Y') {
                                        params.row.promisedDate = new Date().getTime();
                                    } else {
                                        params.row.promisedDate = '';
                                    }
                                    this.summaryData[params.index] = params.row;
                                }
                            }
                        }, selectOption);
                    },
                    width: 60
                }
            ],
            summarySelection: [],
            total2: 0,
            page2: 1,
            pageSize2: 300
        };
    },
    components: {
        mQuery,
    },
    methods: {
        beforeSubmit () {
            if (this.billTab === 'detailed') {
                this.queryCanConfirmNotify();
            } else {
                this.queryCanConfirmNotifySum();
            }
        },
        // 明细查询
        queryCanConfirmNotify () {
            this.loading = true;
            if (this.INT_NOTIFY_REJECT_ORG.find((item) => item.code === this.getFormDataItemObj(this.formData.items, 'orgCode').value)) {
                this.disabledReject = false;
            } else {
                this.disabledReject = true;
            }
            axios.post('/gscint/order/queryCanConfirmNotify', {
                ...this.getFormDataVModel(this.formData.items),
                vendorCode: this.vendorCode,
                pageIndex: this.page1,
                pageSize: this.pageSize1,
                language: this.$i18n.locale
            })
            .then((res) => {
                this.loading = false;
                this.detailedSelection = [];
                let data = res.data.data;
                if (data.code === '1') {
                    this.detailedData = data.datas.list;
                    this.total1 = data.datas.total;
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // 汇总查询
        queryCanConfirmNotifySum () {
            this.loading = true;
            axios.post('/gscint/order/queryCanConfirmNotifySum', {
                ...this.getFormDataVModel(this.formData.items),
                vendorCode: this.vendorCode,
                pageIndex: this.page2,
                pageSize: this.pageSize2,
                language: this.$i18n.locale
            })
            .then((res) => {
                this.loading = false;
                this.summarySelection = [];
                let data = res.data.data;
                if (data.code === '1') {
                    data.datas.list.map((item) => {
                        item.selectFlag = 'Y';
                        return item;
                    });
                    this.summaryData = data.datas.list;
                    this.total2 = data.datas.total;
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        tabClick (name) {
            this.billTab = name;
            const tableName = name === 'detailed' ? 'detailedTable' : 'summaryTable';
            this.tableRefName = tableName;
            this.parent = tableName;
            this.clearFixedStyle();
            this.initFixedHeader();
            this.resetTableScrollBar();
            this.initScrollBar();
        },
        // 明细确认
        beforeConfirmDetailed () {
            let detailList = this.$refs.detailedTable.getSelection();
            if (detailList.find((item) => item.selectFlag === 'N' && !item.rejectReason)) {
                this.$Modal.error({
                    content: this.$t('deliveryNoticeConfirm.t44')
                })
                return false;
            }
            this.loading = true;
            axios.post('/gscint/order/confirmNotify', {
                publicParams: {
                    vendorCode: this.vendorCode
                },
                detailList
            })
            .then((res) => {
                this.loading = false;
                let data = res.data.data;
                if (data.code !== '-1') {
                    this.$Modal.success({
                        content: data.msg
                    });
                    this.queryCanConfirmNotify();
                } else {
                    this.$Modal.error({
                        content: data.msg
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // 明细导出
        exportOutDetailed () {
            this.exportExcel('/gscint/order/exportCanConfirmNotify');
        },
        handleDetailedSelectionChange (selection) {
            this.detailedSelection = selection;
        },
        onPageSizeChange1 (pageSize) {
            this.pageSize1 = pageSize;
            this.$refs.searchForm.$refs.formData.validate((valid) => {
            });
        },
        // 汇总确认
        confirmSummary () {
            this.loading = false;
            axios.post('/gscint/order/confirmNotifySum', this.$refs.summaryTable.getSelection())
            .then((res) => {
                this.loading = false;
                let data = res.data.data;
                if (data.code !== '-1') {
                    this.$Modal.success({
                        content: data.msg
                    });
                    this.queryCanConfirmNotifySum();
                } else {
                    this.$Modal.error({
                        content: data.msg
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // 汇总导出
        exportOutSummary () {
            this.exportExcel('/gscint/order/exportCanConfirmNotifySum');
        },
        exportExcel (url) {
            if (this.$refs.searchForm.validateForm()) {
                this.loading = true;
                window.open(`${url}?paraJson=${encodeURI(JSON.stringify(
                    {
                        ...this.getFormDataVModel(this.formData.items),
                        vendorCode: this.vendorCode,
                        language: this.switchLanguage(this.$i18n.locale)
                    }
                ))}`);
                setTimeout(() => {
                    this.loading = false;
                }, 5000);
            }
        },
        handleSummarySelectionChange (selection) {
            this.summarySelection = selection;
        },
        onPageChange1 (page) {
            this.page1 = page;
        },
        onPageChange2 (page) {
            this.page2 = page;
        },
        onPageSizeChange1 (pageSize) {
            this.pageSize1 = pageSize;
        },
        onPageSizeChange2 (pageSize) {
            this.pageSize2= pageSize;
        },
        setTableUpdate(columns) {
            this.detailedCols = columns;
        },
        setSummaryTableUpdate(columns) {
            this.summaryCols = columns;
        },
    },
    mounted () {
        this.getSRMInvLovListNew((data) => {
            let list = [];
            data.forEach((item) => {
                list.push({
                    label: item.organizationName,
                    value: item.organizationCode
                });
            });
            this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = list;
        });
        this.getDict('INT_PM_FD_FEED_TYPES', (data) => {
            this.getFormDataItemObj(this.formData.items, 'sourceTypeCode').options.values = data;
        });
        this.getDict('INT_NOTIFY_REJECT_ORG', (data) => {
            this.INT_NOTIFY_REJECT_ORG = data;
        });
    }
};
</script>